import { render, staticRenderFns } from "./drag-table.vue?vue&type=template&id=5a77e163&scoped=true&"
import script from "./drag-table.vue?vue&type=script&lang=js&"
export * from "./drag-table.vue?vue&type=script&lang=js&"
import style0 from "./drag-table.vue?vue&type=style&index=0&id=5a77e163&prod&lang=css&"
import style1 from "./drag-table.vue?vue&type=style&index=1&id=5a77e163&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a77e163",
  null
  
)

export default component.exports